import apiService from '@/services/api';
import logger from '@/services/logger';
import RecursiveError from '@/services/recursiveError';

export const setBattery = async (batteryInfo, locationId) => {
	try {
		const response = await apiService.post(`/locations/${locationId}/batteries`, batteryInfo);

		if (response && response.data) {
			return response.data.id;
		}

		throw new RecursiveError('response.data does not exist.');
	} catch (err) {
		logger.error('Failed to send battery to server', err);

		throw err;
	}
};

export const setCollectionOrder = async (locationId, orderData) => {
	try {
		const response = await apiService.post(`/locations/${locationId}/collectionorders`, orderData);

		if (response && response.data) {
			return response.data;
		}

		throw new RecursiveError('Response of create collection order call was empty');
	} catch (err) {
		logger.error('Failed to send battery to server', err);

		throw err;
	}
};

export const setPackaging = async (packagingData, locationId) => {
	try {
		const response = await apiService.post(`/locations/${locationId}/packaging`, packagingData);

		if (response && response.data) {
			return response.data.id;
		}

		throw new RecursiveError('response.data does not exist.');
	} catch (err) {
		logger.error('Failed to send battery to server', err);

		throw err;
	}
};

export const deleteBattery = async batteryId => {
	try {
		const response = await apiService.delete(`/batteries/${batteryId}`);

		if (response && response.data) {
			return response.data;
		}

		throw new RecursiveError('response.data does not exist.');
	} catch (err) {
		logger.error('Failed to send battery to server', err);

		throw err;
	}
};

export const patchBattery = async (batteryId, batteryInfo) => {
	try {
		const response = await apiService.patch(`/batteries/${batteryId}`, batteryInfo);

		if (response && response.data) {
			return response.data;
		}

		throw new RecursiveError('response.data does not exist.');
	} catch (err) {
		logger.error('Failed to send battery to server', err);

		throw err;
	}
};
